export const RENTAL_PLANS = [
  { value: 'NORMAL', label: 'NORMAL' },
  { value: 'FOB', label: 'FOB' },
  { value: 'DEMONSTRACAO', label: 'DEMONSTRAÇÃO' },
  { value: 'SMART', label: 'SMART' },
];
